module.exports = NotificationsLabels;